var map = {
	"./add-favorite.js": "Xfwn",
	"./cancel-app-install.js": "ayTs",
	"./fetch-all-apps.js": "veL4",
	"./fetch-app.js": "eCLZ",
	"./fetch-collection.js": "rONa",
	"./fetch-developer-apps.js": "YDA2",
	"./fetch-features-and-user.js": "qSGy",
	"./fetch-has-gallery-grant.js": "oabH",
	"./fetch-installed-app-status.js": "Iydr",
	"./fetch-installed-apps-status.js": "iJ0n",
	"./fetch-installed-apps.js": "COCk",
	"./fetch-page-layout.js": "+Y3g",
	"./mark-app-installed.js": "TscY",
	"./mark-app-removed.js": "mu7T",
	"./mark-tile-installed.js": "KnHN",
	"./mark-tile-removed.js": "hl4f",
	"./rate-app.js": "XIzo",
	"./remove-favorite.js": "UIvS",
	"./reposition-tiles.js": "/XzC",
	"./search-all-apps.js": "vXKj",
	"./search-developer-apps.js": "Z3y0",
	"./search-developer-preview.js": "ZVPo",
	"./search-preview.js": "Q3Al",
	"./set-app-id.js": "pGDe",
	"./set-pending-app-install-status.js": "/6OK",
	"./set-pending-tile-install-status.js": "BavF",
	"./unrate-app.js": "5viZ",
	"./update-permissions.js": "hojM"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "E3HQ";